export default {
  'environments.title': 'Manage Environments',
  'environments.type.development': 'Development',
  'environments.type.testing': 'Testing',
  'environments.type.production': 'Production',
  'environments.permissions.description': 'Add or remove who can access the environment {name}.',
};
